import { returnStringOrNull } from './type-check'

class storage {
  /**
   * Set store item.
   *
   * @param itemKey
   * @param value
   */
  setItem(itemKey, value) {
    sessionStorage.setItem(`${itemKey}`, `${value}`)
  }

  /**
   * Get store item.
   *
   * @param itemKey
   * @returns {string}
   */
  getItem(itemKey) {
    return returnStringOrNull(sessionStorage.getItem(`${itemKey}`))
  }

  /**
   * Remove store item.
   *
   * @param itemKey
   */
  removeItem(itemKey) {
    sessionStorage.removeItem(`${itemKey}`)
  }
}

export default new storage()
